// History access requires a subscription. Credit packs do not unlock it.
// The feature preview continues to the platform's subscription purchase flow.
export function openPlusHistoryUpgrade(openModal, source) {
  openModal('PlusFeatureModal', {
    feature: 'history',
    source,
  });
}
